import { Injectable } from '@angular/core';
import { DateServiceInterface } from '@shared/services/date/date.service.interface';
import moment from 'moment';
import { DateFormat } from '../../../types/date';

const DATE_FORMAT = DateFormat.ISO;
@Injectable()
export class MomentDateService implements DateServiceInterface {
  getCurrentDate(): string {
    return moment().format(DATE_FORMAT);
  }

  addDays(date: string, days: number): string {
    return moment(date).add(days, 'days').format(DATE_FORMAT);
  }

  addMonths(date: string, months: number): string {
    return moment(date).add(months, 'months').format(DATE_FORMAT);
  }

  formatDate(date: string, from: string, to: string): string {
    return moment(date, from).format(to);
  }

  isValid(date: string, format: string): boolean {
    return moment(date, format).isValid();
  }

  getDiffInDays(start: string, end: string): number {
    return moment(start).diff(moment(end), 'days');
  }

  addMonthFromDate(date: number, month: number): string {
    return moment().add(month, 'month').date(date).format(DATE_FORMAT);
  }

  addYears(date: string, years: number): string {
    return moment(date).add(years, 'year').format(DATE_FORMAT);
  }

  isBefore(start: string, end: string): boolean {
    return moment(start).isBefore(end);
  }
}
